import { useMemo } from 'react';

import { ERROR_SEVERITY, WARNING_SEVERITY } from '../../components/compact-error/constants';
import { emptyArray } from 'ui-components/default-props/empty';
import { useFulfillmentPlannerContext } from '../context';

export const useRateWarningsAndErrors = () => {
  const { rateErrors, didLabelCreationFail, warnings } = useFulfillmentPlannerContext();

  const shouldShowErrors = !!rateErrors?.length && !didLabelCreationFail;
  const shouldShowWarnings = !shouldShowErrors && !!warnings.length;

  const uniqueErrors = useMemo(() => {
    if (!shouldShowErrors) {
      return emptyArray;
    }

    return rateErrors.reduce((uniques, err) => {
      if (uniques.find((ue) => ue.defaultMessage === err.defaultMessage)) {
        return uniques;
      }
      return [...uniques, err];
    }, []);
  }, [rateErrors, shouldShowErrors]);

  return useMemo(() => {
    return {
      shouldShowWarnings,
      shouldShowErrors,
      warnings,
      errors: uniqueErrors,
      errorSeverity: didLabelCreationFail ? ERROR_SEVERITY : WARNING_SEVERITY,
    };
  }, [didLabelCreationFail, shouldShowErrors, shouldShowWarnings, uniqueErrors, warnings]);
};
